import { l } from 'client/Other/Translation'
import * as React from 'react'
import { connect } from 'react-redux'
import IOSBadgeDEIcon from 'static/images/appStore/Download_Badge_DE.svg'
import IOSBadgeENIcon from 'static/images/appStore/Download_Badge_EN.svg'
import IOSBadgeFIIcon from 'static/images/appStore/Download_Badge_FI.svg'
import IOSBadgeFRIcon from 'static/images/appStore/Download_Badge_FR.svg'
import IOSBadgeNLIcon from 'static/images/appStore/Download_Badge_NL.svg'
import IOSBadgeSEIcon from 'static/images/appStore/Download_Badge_SE.svg'

import { StateInterface } from '../Interfaces/StateInterface'
import './MobileWelcome.scss'

export interface MobilePropsInterface {
  onMobileContinue(): void
  language: string
}

function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone'
  }

  if (/android/i.test(userAgent)) {
    return 'Android'
  }

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS'
  }

  return 'unknown'
}

interface BadgeProps {
  language: string
}

const IOSBadge: React.FC<BadgeProps> = ({ language }) => {
  const country = language === 'en' ? 'gb' : language
  const icons = {
    en: IOSBadgeENIcon,
    fr: IOSBadgeFRIcon,
    sv: IOSBadgeSEIcon,
    de: IOSBadgeDEIcon,
    fi: IOSBadgeFIIcon,
    nl: IOSBadgeNLIcon,
  }

  return (
    <a
      href={`https://apps.apple.com/${country}/app/zervant/id1455614624?utm_source=intercom&amp;utm_medium=email&amp;utm_campaign=mobile_launch`}
    >
      <img src={icons[language]} alt="Download on the App Store" />
    </a>
  )
}

const AndroidBadge: React.FC<BadgeProps> = ({ language }) => {
  return (
    <a href={`https://play.google.com/store/apps/details?id=com.zervant.invoicing&hl=${language}`}>
      <img
        style={{ height: '60px' }}
        alt="Get it on Google Play"
        src={`https://play.google.com/intl/en_us/badges/images/generic/${language}_badge_web_generic.png`}
      />
    </a>
  )
}

const supportedLanguages = ['en', 'sv', 'fr', 'fi', 'de', 'nl']

export class MobileWelcome extends React.Component<MobilePropsInterface, any> {
  private onMobileContinue() {
    this.props.onMobileContinue()
  }

  public render() {
    let { language } = this.props
    language = supportedLanguages.includes(language) ? language : 'en'
    return (
      <div className="mobile-welcome">
        <div className="header">
          <h2>{l('mobileSignUp.recommend')}</h2>
        </div>
        {getMobileOperatingSystem() === 'iOS' ? <IOSBadge language={language} /> : <AndroidBadge language={language} />}
        <br />
        <div className="button-wrapper">
          <p className="optimizedFor">
            {l('mobileSignup.optimizedForDesktop') + ' '}
            <a className="continue" onClick={() => this.onMobileContinue()}>
              {l('mobileSignup.continueLink')}
            </a>
          </p>
        </div>
      </div>
    )
  }
}

export default connect(
  (state: StateInterface) => ({ language: state.token.locale.split('_')[0] }),
  (dispatch) => ({}),
)(MobileWelcome)
